import { makeAutoObservable } from 'mobx';

class ErrorModalStore {
  message: string | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  show = (message: string) => {
    this.message = message;
  };

  dismiss = () => {
    this.message = null;
  };
}

export const errorModalStore = new ErrorModalStore();
